"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_mobile_1 = require("antd-mobile");
var react_1 = __importDefault(require("react"));
var Items = function (props) {
    var service = props.service;
    return (react_1.default.createElement(antd_mobile_1.Swiper, { className: "list", loop: true }, service.map(function (obj, index) { return (react_1.default.createElement(antd_mobile_1.Swiper.Item, { key: index },
        react_1.default.createElement("div", { className: "list-items" },
            react_1.default.createElement("span", { className: "list-items__title" }, obj.span),
            react_1.default.createElement("time", { className: "list-items__desc" }, obj.time)))); })));
};
exports.default = Items;
//# sourceMappingURL=Items.js.map